import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = {
  key: 3,
  d: "m12 2 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"
}
const _hoisted_3 = {
  key: 4,
  d: "M12 22V12M12 16C5 16 3 12 3 6c6 0 9 3 9 8M12 11c0-6 3-9 9-9 0 6-3 9-9 9"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryIcon',
  props: {
    type: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_ctx.type === 'voice')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("rect", {
            x: "9",
            y: "2",
            width: "6",
            height: "13",
            rx: "3"
          }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("path", { d: "M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8" }, null, -1))
        ], 64))
      : (_ctx.type === 'text')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[2] || (_cache[2] = _createElementVNode("path", { d: "M21 11a8 8 0 0 1-8 8H7l-5 3 1-6a8 8 0 0 1-1-4V9a7 7 0 0 1 7-7h5a7 7 0 0 1 7 7z" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("path", { d: "M7 8h9M7 12h6" }, null, -1))
          ], 64))
        : (_ctx.type === 'either')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[4] || (_cache[4] = _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "5",
                height: "10",
                rx: "2.5"
              }, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("path", { d: "M1 10v1a4.5 4.5 0 0 0 9 0v-1M5.5 15.5V20M3 20h5M13 4h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3l-4 3V8M16 8h3M16 11h3" }, null, -1))
            ], 64))
          : (_ctx.type === 'experienced')
            ? (_openBlock(), _createElementBlock("path", _hoisted_2))
            : (_openBlock(), _createElementBlock("path", _hoisted_3))
  ]))
}
}

})